import React, {useState} from 'react'
import {Popup, Modal, Input, Button, Heading} from '../'
import {Edit, Plus, Delete, Briefcase, MagicWand} from '../Icons/Icons'
import { doc, getDoc, setDoc, addDoc, collection, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";

import styles from './DocMenu.module.css'

function DocMenu({docId, currentDoc, onClose, docs, setDocs, getResumes}){

	const [showRenameModal, toggleRenameModal] = useState(false)
	const [showCopyModal, toggleCopyModal] = useState(false)
	const [showDeleteModal, toggleDeleteModal] = useState(false)
	const [newName, setNewName] = useState('')
	const [showPopup, togglePopup] = useState(true)
	const [loading, setLoading] = useState(false)

	const handleRename = (e) => {
		e.preventDefault();
		e.stopPropagation();
		toggleRenameModal(true)
	}

	const handleCopy = (e) => {
		e.preventDefault();
		e.stopPropagation();
		toggleCopyModal(true)
	}

	const handleDelete = (e) => {
		e.preventDefault();
		e.stopPropagation();
		toggleDeleteModal(true)
	}

	const doUpdateName = async () => {
		setLoading(true)
		const docRef = doc(db, "documents", docId);
		await setDoc(docRef, { name: newName }, { merge: true });
		currentDoc.name = newName
		setLoading(false)
		onClose()
	}

  const getDocData = async () => {
    const docDataRef = doc(db, "documentData", currentDoc.docDataRef);
    const docDataSnap = await getDoc(docDataRef);
    if (docDataSnap.exists()) {
    	return docDataSnap
    }
  };

	const doCopyResume = async () => {
		setLoading(true)
		const {color, design, fontSize, user, name} = currentDoc

		const docDataRef = await getDocData();
		const resumeInfo = docDataRef.data()

		const newDocDataRef = await addDoc(
      collection(db, "documentData"), resumeInfo || {}
    );

		const resumeObj = {
			color,
			design,
	    user,
	    fontSize,
	    name: `Copy - ${name}`,
	    docDataRef: newDocDataRef.id,
	    createdAt: new Date(),
	  };

	  await addDoc(collection(db, "documents"), resumeObj);
	  setLoading(false)
	  onClose()
	  getResumes()
	}

	const doDeleteResume = async () => {
		setLoading(true)
		try{
			const docDataRef = doc(db, 'documentData', currentDoc.docDataRef);
			await deleteDoc(docDataRef);
			const docRef = doc(db, 'documents', docId);
			await deleteDoc(docRef);
		}
		catch(err){
			console.log(err)
		}
		finally{
			setLoading(false)
			onClose();
			getResumes()
		}
	}

	return(
		<>
			<Popup 
				className={styles.docMenuPopup} 
				onClose={onClose}
			>
	      <button onClick={handleRename}><Edit /> Rename</button>
				<button onClick={handleCopy}><Plus /> Make a Copy</button>
				<button onClick={handleDelete}><Delete /> Delete</button>
	    </Popup>
      <Modal active={showRenameModal}>
        <div className={styles.renameModal}>
          <div className="">
            <Input
              label="Enter New Name"
              placeholder={currentDoc.name}
              onChange={(e) => setNewName(e.target.value)}
          	/>
            <div className={styles.renameActions}>
	            <Button
	            	outlined
	            	content="Cancel"
	            	onClick={onClose}
	            	disabled={loading}
	            />
	            <Button
	              content="Change Name"
	              disabled={newName == ""}
	              onClick={doUpdateName}
	              loading={loading}
	            />
		        </div>
          </div>
      	</div>
      </Modal>
      <Modal active={showCopyModal}>
        <div className={styles.copyModal}>
        	<div className={styles.iconWrapper}>
          	<MagicWand />
        	</div>	
           <p className={styles.copyTitle}> Are you sure you want to make copy of "{currentDoc.name}"</p>
          <div className={styles.renameActions}>
            <Button
            	outlined
            	content="Cancel"
            	onClick={onClose}
            	disabled={loading}
            />
            <Button
              content="Copy Resume"
              onClick={doCopyResume}
              loading={loading}
            />
        	</div>
        </div>
      </Modal>
      <Modal active={showDeleteModal}>
        <div className={styles.copyModal}>
        	<div className={styles.iconWrapper}>
          	<Delete />
        	</div>	
           <p className={styles.copyTitle}>Delete "{currentDoc.name}"?</p>
           <p style={{fontSize: '12px', marginBottom: '54px'}}>Deleting this resume is permanent and cannot be undone. You won’t be able to restore it later.</p>
          <div className={styles.renameActions}>
            <Button
            	outlined
            	content="Cancel"
            	onClick={onClose}
            	disabled={loading}
            />
            <Button
              content="Delete Resume"
              onClick={doDeleteResume}
              loading={loading}
            />
        	</div>
        </div>
      </Modal>
	</>

		)
}

export default DocMenu